export enum TEAM_TAB {
  ALL = 'all',
  PENDING = 'pending',
}
